import React from 'react';
import type { AdminChatAssistGoogleSearchGrounding } from '../../models/admin/AdminChatAssistGoogleSearchGrounding';
import type { ChatLinkTarget } from '../../utils/chatLinkCorpus';
import VeraGroundedMessage from '../VeraGroundedMessage';
import ChatLinkifiedMessageText from './ChatLinkifiedMessageText';

interface AdminAssistGroundedSuggestionProps {
  messageId: string;
  text: string;
  corpus: ChatLinkTarget[] | null;
  grounding: AdminChatAssistGoogleSearchGrounding | null | undefined;
  markdownVariant?: 'inline' | 'block';
}

export default function AdminAssistGroundedSuggestion({
  messageId,
  text,
  corpus,
  grounding,
  markdownVariant = 'block',
}: AdminAssistGroundedSuggestionProps) {
  const hasGrounding = !!(grounding?.sources?.length || grounding?.citations?.length);
  const useInlineCitations = !!(grounding?.citations?.length && grounding?.sources?.length);

  if (!hasGrounding || !useInlineCitations) {
    return (
      <ChatLinkifiedMessageText
        messageId={messageId}
        text={text}
        corpus={corpus}
        markdownVariant={markdownVariant}
      />
    );
  }

  return (
    <VeraGroundedMessage text={text} grounding={grounding} markdownVariant={markdownVariant} />
  );
}
